
    import '/Users/jilin/projects/antd/rc-dialog/docs/demo/pure.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"pure-debug","toc":"menu","filename":"docs/demo/pure.md","lastUpdated":1674027995000,"nav":{"title":"Demo","path":"/demo"}};